// extracted by mini-css-extract-plugin
module.exports = {"root":"CartActionPopup_root__2zQWL"};